export { default as getData } from './method-get';
export { default as deleteData } from './method-delete';
export { default as postData } from './method-post';
export { default as putData } from './method-put';

function isUndefinedOrNull(value: any) {
  return value === undefined || value === null;
}

export const withParam = (url: string, param: Record<string, any>) => {
  Object.keys(param ?? {}).forEach(item => {
    if (isUndefinedOrNull(param?.[item])) delete param?.[item];
  });
  const _param = param ? `?${new URLSearchParams(param)}` : '';
  return url + _param;
};
